/**
 * Platform-agnostic storage service interface
 * Implementations:
 * - Web: localStorage
 * - Mobile: AsyncStorage
 */
export interface IStorageService {
  getItem(key: string): Promise<string | null>;
  setItem(key: string, value: string): Promise<void>;
  removeItem(key: string): Promise<void>;
  clear(): Promise<void>;
}

// Storage instance will be set by platform-specific implementation
let storageInstance: IStorageService | null = null;

export const setStorageImplementation = (implementation: IStorageService) => {
  storageInstance = implementation;
};

export const storage: IStorageService = {
  async getItem(key: string): Promise<string | null> {
    if (!storageInstance) {
      throw new Error('Storage implementation not set. Call setStorageImplementation first.');
    }
    return storageInstance.getItem(key);
  },

  async setItem(key: string, value: string): Promise<void> {
    if (!storageInstance) {
      throw new Error('Storage implementation not set. Call setStorageImplementation first.');
    }
    return storageInstance.setItem(key, value);
  },

  async removeItem(key: string): Promise<void> {
    if (!storageInstance) {
      throw new Error('Storage implementation not set. Call setStorageImplementation first.');
    }
    return storageInstance.removeItem(key);
  },

  async clear(): Promise<void> {
    if (!storageInstance) {
      throw new Error('Storage implementation not set. Call setStorageImplementation first.');
    }
    return storageInstance.clear();
  }
};
